import { render, staticRenderFns } from "./OrderInfoData.vue?vue&type=template&id=c4e0157e&"
import script from "./OrderInfoData.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports